var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"split-block",class:{ 'split-block--inverted': _vm.inverted },style:(_vm.splitBlockStyle)},[_c('div',{staticClass:"split-block__item-1"},[_vm._t("item1")],2),_c('div',{staticClass:"split-block__item-2"},[_vm._t("item2")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }